"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
import { type ReactNode } from "react";
export interface TooltipRow {
  color: string;
  label: string;
  value: string | number;
}
export interface TooltipContentProps {
  title?: string;
  rows: TooltipRow[];
  /** Optional additional content (e.g., markers) */
  children?: ReactNode;
}
export function TooltipContent(t0) {
  const $ = _c(15);
  const {
    title,
    rows,
    children
  } = t0;
  const hasChildren = !!children;
  const markerKey = hasChildren ? "has-marker" : "no-marker";
  let t1;
  if ($[0] !== title) {
    t1 = title && <div className="text-chart-tooltip-foreground mb-2 text-xs font-medium">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rows) {
    t2 = rows.map(_temp);
    $[2] = rows;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="space-y-1.5">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== markerKey) {
    t4 = children && <motion.div animate={{
      opacity: 1,
      filter: "blur(0px)"
    }} className="mt-2" exit={{
      opacity: 0,
      filter: "blur(4px)"
    }} initial={{
      opacity: 0,
      filter: "blur(4px)"
    }} key={markerKey} transition={{
      duration: 0.2,
      ease: "easeOut"
    }}>{children}</motion.div>;
    $[6] = children;
    $[7] = markerKey;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <AnimatePresence mode="wait">{t4}</AnimatePresence>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t5) {
    t6 = <div className="px-3 py-2.5">{t1}{t3}{t5}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(row) {
  return <div className="flex items-center justify-between gap-4" key={`${row.label}-${row.color}`}><div className="flex items-center gap-2"><span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{
        backgroundColor: row.color
      }} /><span className="text-chart-tooltip-muted text-sm">{row.label}</span></div><span className="text-chart-tooltip-foreground text-sm font-medium tabular-nums">{typeof row.value === "number" ? row.value.toLocaleString() : row.value}</span></div>;
}
TooltipContent.displayName = "TooltipContent";
export default TooltipContent;